import { TabBar } from '@tmov/design-system';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { useListaDocumentosContext } from '../../../../../../../contexts/ListaDocumentos';
import { TabBarCustomStyle } from './styles';
import TabAcompanhamento from './TabAcompanhamento';
import TabDocumentos from './TabDocumentos';

function TrackingTabs({
  dadosMotorista,
  eventosMotorista,
  documentosMotorista,
}) {
  const [currentTab, setCurrenTab] = useState(1);
  const { updateDocumentosAction } = useListaDocumentosContext();

  useEffect(() => {
    setCurrenTab(1);
    if (documentosMotorista) {
      updateDocumentosAction(documentosMotorista, dadosMotorista.StatusInt);
    }
  }, [dadosMotorista.StatusInt, documentosMotorista, updateDocumentosAction]);

  return (
    <>
      <TabBarCustomStyle />
      <TabBar
        onChange={setCurrenTab}
        selectedTabId={currentTab}
        tabs={[
          {
            id: 1,
            title: 'Acompanhamento',
            content: (
              <TabAcompanhamento
                dadosMotorista={dadosMotorista}
                eventos={eventosMotorista}
              />
            ),
          },
          {
            id: 2,
            title: 'Documentos',
            content: (
              <TabDocumentos
                documentosMotorista={documentosMotorista}
                protocolo={dadosMotorista.Protocolo}
                idLoteConjunto={dadosMotorista.IdLoteConjunto}
              />
            ),
          },
        ]}
      />
    </>
  );
}

const docsShape = PropTypes.shape({
  id: PropTypes.string,
  tipoDocumento: PropTypes.number,
  tipoDocumentoDescricao: PropTypes.string,
  dataCriacao: PropTypes.string,
});
const eventosShape = PropTypes.shape({
  status: PropTypes.string,
  nomeAutor: PropTypes.string,
  dataAlteracao: PropTypes.string,
});

TrackingTabs.propTypes = {
  dadosMotorista: PropTypes.shape({
    IdLoteConjunto: PropTypes.number,
    IdLote: PropTypes.number,
    Nome: PropTypes.string,
    PlacaCavalo: PropTypes.string,
    Peso: PropTypes.string,
    EntradaFila: PropTypes.string,
    StatusInt: PropTypes.number,
    DataEmissaoCte: PropTypes.string,
    IsTransportadoraExterna: PropTypes.bool,
    NomeTransportadora: PropTypes.string,
    Status: PropTypes.string,
    Protocolo: PropTypes.string,
    IdFilial: PropTypes.number,
    LatitudeCheckin: PropTypes.number,
    LongitudeCheckin: PropTypes.number,
    UltimoCheckin: PropTypes.string,
    Cpf: PropTypes.string,
  }),
  eventosMotorista: PropTypes.arrayOf(eventosShape).isRequired,
  documentosMotorista: PropTypes.arrayOf(docsShape),
};

TrackingTabs.defaultProps = {
  dadosMotorista: {},
  documentosMotorista: [],
};
export default TrackingTabs;
